const imagesContext = require.context('../images', true, /\.svg$/i);
imagesContext.keys().forEach(imagesContext);